// Imports
import modalHelpers from '../../../../../../../shareables/front-end/modal/modal-helpers';
import ActionLink from '../../../../../shared-components/action-link';


// Function component
const AskGenderModalNote: React.FC = () => {
	// Return JSX
	return (
		<em>
			Your gender is never displayed to others.{' '}
			<ActionLink onClick={() => modalHelpers.show('ask-gender-modal')}>Learn more</ActionLink> about why we ask for
			this information.
		</em>
	);
};

export default AskGenderModalNote;
